import { defineComponent as _defineComponent } from 'vue'
import {WarrantyService} from '../../../services/WarrantyService'
import {onMounted, reactive, ref} from "vue";
import {useRoute, useRouter} from 'vue-router/composables'
import i18n from "@/i18n";
import {WarrantyUserType} from "@/types/WarrantyUserType";
import {WarrantyType} from "@/types/WarrantyType";
import DatePickerInput from "@/components/base/DatePickerInput.vue";
import {WarrantySearchModelType} from "@/types/WarrantySearchModelType";
import {WarrantySaveType} from "@/types/WarrantySaveType";
import {store} from "@/store";
import {WarrantyLocationInfoService} from "@/services/WarrantyLocationInfoService";
import {KeycloakService, warrantyDeleteRoles, warrantyEditRoles} from "@/services/KeycloakService";
import {Warranty} from "@/types/RemoteTypes";

import * as dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetail',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const message = ref<string | (string | null)[]>('')
const messageType = ref<string | (string | null)[]>('yellow')
const userId = ref('')
const user: WarrantyUserType | any = ref({})
const editedItem: WarrantyType | any = ref({
  serialNumbers: '',
  thirdPartyAllowed: false
})
const editedIndex = ref<number>(-1)
const editUser = ref(false)
const couponItem: WarrantyType | any = ref({})
const dialogDeleteUser = ref(false)
const dialogMergeUser = ref(false)
const dialogAddWarranty = ref(false)
const dialogDownloadAll = ref(false)
const editWarrantyDialog = ref(false)
const deleteWarrantyDialog = ref(false)
const warrantyCouponDialog = ref(false)
const snackbar = ref(false)
const warranties = ref([])
const headers = ref([
  {text: i18n.t('SerialNo'), value: 'serialNumber', sortable: false},
  {text: i18n.t('Description'), value: 'description', sortable: false},
  {text: i18n.t('Tpg'), value: 'tpgName', sortable: false},
  {text: i18n.t('Domain'), value: 'domain', sortable: false},
  {text: i18n.t('Merchant'), value: 'merchant', sortable: false},
  {text: i18n.t('InvoiceNo'), value: 'invoiceNo', sortable: false},
  {text: i18n.t('Registration Date'), value: 'registrationDate', sortable: false},
  {text: i18n.t('Warrantyduration'), value: 'warranty', sortable: false},
  {text: i18n.t('Actions'), value: 'actions', sortable: false},
])
const searchedMergeUser = ref([])
const searchModel = reactive<WarrantySearchModelType>({
  email: '',
  serialnumber: '',
  firstname: '',
  lastname: '',
})
const downloadableLocale = ref<string>('')

const warrantySearch = ref<string>('')

onMounted(() => {
  WarrantyLocationInfoService.getCountries()
  // @ts-ignore
  userId.value = route.params.id
  WarrantyService.getUser(userId.value)
      .then(value => {
        value.origLocale = value.locale
        if (value.locale) {
          value.locale = value.locale.substring(0, 2)
        }
        user.value = value
        user.value.country = user.value.country.toLowerCase()
        downloadableLocale.value = value.locale
        getWarranties()
        WarrantyLocationInfoService.getLocales(user.value.country)
        WarrantyLocationInfoService.getDomains(user.value.country)
      })
      .catch(reason => {
        if (reason['errors'] !== undefined) {
          console.log(reason)
          router.push({
            name: 'warranty',
            query: {message: reason['errors']}
          })
        } else {
          console.log(reason)
          router.push({
            name: 'warranty',
            query: {message: "User could not be loaded, please try again later"}
          })
        }
      });
})

function getWarranties() {
  WarrantyService.getUserWarranties(userId.value, i18n.locale)
      .then(value => {
        warranties.value = value.data
      })
      .catch(reason => {
        if (reason['error'] !== undefined) {
          console.log(reason)
          displayMessage(reason['error'])
        } else {
          console.log(reason)
          displayMessage("Warranties could not be loaded, please try again later")
        }
      });
}

function saveUser() {
  message.value = ""
  if (validateUser(user.value)) {
    WarrantyService.updateUser(userId.value, user.value)
        .then(() => {
          editUser.value = false
          displayMessage('User saved', 'success')
          getWarranties()
          downloadableLocale.value = user.value.locale
          WarrantyLocationInfoService.getLocales(user.value.country)
          WarrantyLocationInfoService.getDomains(user.value.country)
        })
        .catch(reason => {
          if (reason['msg'] !== undefined) {
            displayMessage(reason['msg'])
          } else {
            displayMessage('default_error_message')
          }
        });
  }
}

function validateUser(user: WarrantyUserType) {
  if (!user.email) {
    displayMessage('E-mail must not be empty')
    return false;
  }
  if (!user.firstname) {
    displayMessage('Firstname must not be empty')
    return false;
  }
  if (!user.lastname) {
    displayMessage('Lastname must not be empty')
    return false;
  }
  if (!user.zip) {
    displayMessage('Zip must not be empty')
    return false;
  }
  if (!user.city) {
    displayMessage('City must not be empty')
    return false;
  }
  if (!user.street) {
    displayMessage('Street must not be empty')
    return false;
  }
  if (!user.country) {
    displayMessage('Country must not be empty')
    return false;
  }
  if (!user.locale) {
    displayMessage('Locale must not be empty')
    return false;
  }
  return true;
}

function deleteUser() {
  message.value = ""
  WarrantyService.deleteUser(userId.value)
      .then(() => {
        dialogDeleteUser.value = false
        router.push({
          name: 'warranty',
        })
      })
      .catch(reason => {
        dialogDeleteUser.value = false
        if (reason['msg'] !== undefined) {
          displayMessage(reason['msg'])
        } else {
          console.log(reason)
          displayMessage('default_error_message')
        }
      });
}

function searchMergeuser() {
  message.value = ""
  WarrantyService.search(searchModel)
      .then(value => {
        searchedMergeUser.value = value
      })
      .catch(reason => {
        if (reason['msg'] !== undefined) {
          displayMessage(reason['msg'])
        } else {
          displayMessage('default_error_message')
        }
      });
}

function createWarranty() {
  message.value = ""
  editedItem.value.serialNumbers = [editedItem.value.serialNumber]
  editedItem.value.thirdPartyAllowed = false
  const newWarranty = {
    serialNumbers: [editedItem.value.serialNumber],
    domain: editedItem.value.domain,
    merchant: editedItem.value.merchant,
    invoiceNo: editedItem.value.invoiceNo,
    purchaseDate: editedItem.value.purchaseDate,
    thirdPartyAllowed: false,
  }

  WarrantyService.createWarranty(userId.value, newWarranty)
      .then(value => {
        if (value['success']['serialNumbers'].length > 0) {
          displayMessage('Warranty created', 'success')
          editedItem.value = Object.assign({}, {})
          warrantySearch.value = ''
          getWarranties()
        }
        if (value["failed"].length > 0) {
          value["failed"].forEach(function (errorMessage: any) {
            console.log(errorMessage)
            displayMessage(errorMessage.errorType, 'error')
          })
        }

      })
      .catch(reason => {
        dialogAddWarranty.value = false
        if (reason['msg'] !== undefined) {
          displayMessage(reason['msg'], 'red')
        } else {
          console.log(reason)
          displayMessage('default_error_message')
        }
      });
}

function mergeUser(newUserId: string) {
  message.value = ""
  WarrantyService.mergeWarranty(userId.value, newUserId)
      .then(value => {
        console.log(value)
        dialogAddWarranty.value = false
        router.push({
          name: "warranty_user_detail",
          params: {id: newUserId},
        })
        window.location.reload()
      })
      .catch(reason => {
        dialogAddWarranty.value = false
        if (reason['msg'] !== undefined) {
          displayMessage(reason['msg'], 'red')
        } else {
          console.log(reason)
          displayMessage('default_error_message')
        }
      });
}

function editWarranty(item: WarrantyType) {
  // @ts-ignore
  editedIndex.value = warranties.value.indexOf(item)
  editedItem.value = Object.assign({}, item)
  editWarrantyDialog.value = true
}

function newWarranty() {
  editedItem.value = {}
  if (store.warranty.availableDomains.length == 1) {
    editedItem.value.domain = store.warranty.availableDomains[0]
  }
  editWarrantyDialog.value = true
}

function updateWarranty(warranty: WarrantySaveType) {
  // @ts-ignore
  const warrantyId = warranty.id
  const warrantyToSave: WarrantySaveType = {
    purchaseDate: warranty.purchaseDate,
    serialNumber: warranty.serialNumber,
    domain: warranty.domain,
    invoiceNo: warranty.invoiceNo,
    merchant: warranty.merchant,
    thirdPartyAllowed: warranty.thirdPartyAllowed,
  }

  message.value = ""
  WarrantyService.updateWarranty(userId.value, warrantyId, user.value.locale, warrantyToSave)
      .then(() => {
        displayMessage('Warranty updated', 'success')
        editedItem.value = Object.assign({}, {})
        getWarranties()
      })
      .catch(reason => {
        dialogAddWarranty.value = false
        if (reason['msg'] !== undefined) {
          displayMessage(reason['msg'], 'red')
        } else {
          console.log(reason)
          displayMessage('default_error_message')
        }
      }).finally(() => {
    editedItem.value = Object.assign({}, {})
  });
}

function deleteWarrantyConfirm() {
  // @ts-ignore
  const warrantyId = editedItem.value.id
  message.value = ""
  WarrantyService.deleteWarranty(userId.value, warrantyId)
      .then(() => {
        closeWarrantyDeleteDialog()
        displayMessage('Warranty deleted', 'success')
        getWarranties()
      })
      .catch(reason => {
        dialogAddWarranty.value = false
        if (reason['msg'] !== undefined) {
          displayMessage(reason['msg'], 'red')
        } else {
          console.log(reason)
          displayMessage('default_error_message')
        }
      });
}

function downloadAll() {
  warranties.value.forEach(function (warranty) {
    // @ts-ignore
    downloadWarranty(warranty.id, warranty.serialNumber)
  })
  dialogDownloadAll.value = false
}

function downloadWarranty(warrantyId: string, serialNumber: string) {
  message.value = ""
  WarrantyService.download(userId.value, warrantyId, downloadableLocale.value)
      .then(value => {
        // @ts-ignore
        download(serialNumber + ".pdf", value)
      })
      .catch(reason => {
        dialogAddWarranty.value = false
        if (reason['msg'] !== undefined) {
          displayMessage(reason['msg'], 'red')
        } else {
          console.log(reason)
          displayMessage('default_error_message')
        }
      });
}

function sendWarranty(warrantyId: string) {
  // @ts-ignore
  const locale = user.value.locale
  message.value = ""
  WarrantyService.sendEmail(userId.value, warrantyId, locale)
      .then(() => {
        displayMessage('Email send successfully', 'success')
      })
      .catch(reason => {
        dialogAddWarranty.value = false
        if (reason['msg'] !== undefined) {
          displayMessage(reason['msg'], 'red')
        } else {
          console.log(reason)
          displayMessage('default_error_message')
        }
      });
}

// eslint-disable-next-line no-undef
function download(filename: string, data: BlobPart) {
  let a = document.createElement("a");
  let file = new Blob([data]);
  const fileURL = window.URL.createObjectURL(file);
  a.href = fileURL;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(fileURL);
  a.remove()
}

function saveWarranty() {
  if (!editedItem.value.serialNumber) {
    displayMessage('Serial number is a mandatory field', 'warning')
    return
  }
  if (!editedItem.value.domain) {
    displayMessage('Domain is a mandatory field', 'warning')
    return
  }
  if (!editedItem.value.merchant) {
    displayMessage('Merchant is a mandatory field', 'warning')
    return
  }
  if (!editedItem.value.invoiceNo) {
    displayMessage('Invoice No is a mandatory field', 'warning')
    return
  }
  if (editedItem.value.invoiceNo.length < 1) {
    displayMessage('Invoice No must be more than 5 characters', 'warning')
    return
  }
  if (!editedItem.value.purchaseDate) {
    displayMessage('Purchasedate is a mandatory field', 'warning')
    return
  }

  if (editedIndex.value > -1) {
    updateWarranty(editedItem.value)
  } else {
    createWarranty()
  }
  closeWarrantyEditDialog()
}

function selectCountry(country: string) {
  WarrantyLocationInfoService.getLocales(country)
  user.value.locale = ''
}

function closeEditUser() {
  editUser.value = false
  WarrantyService.getUser(userId.value)
      .then(value => {
        user.value = value
        user.value.country = user.value.country.toLowerCase()
        downloadableLocale.value = value.locale
      })
      .catch(reason => {
        if (reason['errors'] !== undefined) {
          console.log(reason)
          router.push({
            name: 'warranty',
            query: {message: reason['errors']}
          })
        } else {
          console.log(reason)
          router.push({
            name: 'warranty',
            query: {message: "User could not be loaded, please try again later"}
          })
        }
      });
}

function closeWarrantyEditDialog() {
  editWarrantyDialog.value = false
  editedIndex.value = -1
}

function closeWarrantyDeleteDialog() {
  editedItem.value = Object.assign({}, {})
  editedIndex.value = -1
  deleteWarrantyDialog.value = false
}

function openWarrantyDeleteDialog(item: WarrantyType) {
  editedItem.value = Object.assign({}, item)
  deleteWarrantyDialog.value = true
}

const displayMessage = (messageString: string | (string | null)[], type: string = "warning") => {
  message.value = messageString
  messageType.value = type
  snackbar.value = true
}

const checkEditRole = () => {
  return KeycloakService.roles.some(r => warrantyEditRoles.includes(r))
}

const checkDeleteRole = () => {
  return KeycloakService.roles.some(r => warrantyDeleteRoles.includes(r))
}

function getWarrantyText(item: Warranty): string[] {
  const result: string[] = []
  for (let duration of item.warranties) {
    result.push(`${duration.warrantyType}: ${duration.warrantyDuration}`)
  }

  return result
}

const disableFutureDate = (date: Date) => {
    return date > new Date(new Date().setHours(0, 0, 0, 0));
}

function removeWhiteSpace(text:string) {
  return text.trim();
}

const isCouponCodeAvailable = (item: Warranty): boolean => {
  let available = false
  item.warranties.forEach((warranty) => {
    if (warranty.couponCode && dayjs().isBefore(dayjs(warranty.couponCodeExpiresAt))) {
      available = true
    }
  })

  return available
}

function showCouponsDialog(item: WarrantyType) {
  couponItem.value = Object.assign({}, item)
  warrantyCouponDialog.value = true
  console.log(warrantyCouponDialog)
}

function closeCouponsDialog() {
  couponItem.value = Object.assign({}, {})
  warrantyCouponDialog.value = false
}

return { __sfc: true,router, route, message, messageType, userId, user, editedItem, editedIndex, editUser, couponItem, dialogDeleteUser, dialogMergeUser, dialogAddWarranty, dialogDownloadAll, editWarrantyDialog, deleteWarrantyDialog, warrantyCouponDialog, snackbar, warranties, headers, searchedMergeUser, searchModel, downloadableLocale, warrantySearch, getWarranties, saveUser, validateUser, deleteUser, searchMergeuser, createWarranty, mergeUser, editWarranty, newWarranty, updateWarranty, deleteWarrantyConfirm, downloadAll, downloadWarranty, sendWarranty, download, saveWarranty, selectCountry, closeEditUser, closeWarrantyEditDialog, closeWarrantyDeleteDialog, openWarrantyDeleteDialog, displayMessage, checkEditRole, checkDeleteRole, getWarrantyText, disableFutureDate, removeWhiteSpace, isCouponCodeAvailable, showCouponsDialog, closeCouponsDialog, i18n, DatePickerInput, store, dayjs }
}

})